import React, { useMemo } from "react"

import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import { TooltipElement } from "@front-shared/elements/tooltip.element"

import { TOOLTIPS_CONFIG } from "../../../config/tooltips.config"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { checkerReset } from "../../../store/slices/checker.slice"

import magicWandIcon from "@front-shared/assets/images/icons/magic-wand-white.svg"
import refreshIcon from "@front-shared/assets/images/icons/refresh-dark2.svg"

export const RunCsvChecksFloatingButtonComponent: React.FunctionComponent<
    IRunCsvChecksFloatingButtonComponentProps
> = props => {
    const dispatch = useAppDispatch()

    const invalidInputRowsCount = useMemo<number>(() => {
        return props.totalChecksCount - props.validChecksCount
    }, [props.validChecksCount, props.totalChecksCount])

    const onReset = () => {
        dispatch(checkerReset())
    }

    return (
        <div className="fixed bottom-[24px] z-40 w-screen flex justify-center">
            <div
                className={`
                    flex items-center gap-[8px]
                    py-[12px] pr-[12px]
                    rounded-full bg-brand-whitePurple border border-solid border-brand-lilac
                    ${invalidInputRowsCount ? "pl-[32px]" : "pl-[12px]"}
                `}
            >
                {invalidInputRowsCount ? (
                    <>
                        <TooltipElement
                            className="relative top-[-2px]"
                            text={TOOLTIPS_CONFIG.checker.csvChecksWontRun}
                            placement="top"
                            isAlert
                        />

                        <PrimaryText className="flex-shrink-0">
                            <span className="text-bold">
                                {invalidInputRowsCount} of{" "}
                                {props.totalChecksCount}
                            </span>{" "}
                            checks will not be run
                        </PrimaryText>
                    </>
                ) : null}

                <ButtonElement
                    buttonClassName="min-w-[180px]"
                    type="ghost"
                    htmlType="button"
                    label="Re-upload CSV"
                    icon={refreshIcon}
                    onClick={onReset}
                />

                {props.validChecksCount ? (
                    <ButtonElement
                        buttonClassName="min-w-[180px]"
                        type="primary"
                        htmlType="button"
                        label={`Run ${props.validChecksCount} Check${
                            props.validChecksCount > 1 ? "s" : ""
                        }`}
                        icon={magicWandIcon}
                        onClick={props.onRunCoverageChecks}
                    />
                ) : null}
            </div>
        </div>
    )
}

interface IRunCsvChecksFloatingButtonComponentProps {
    validChecksCount: number
    totalChecksCount: number
    onRunCoverageChecks: () => void
}
